window.onload = function() {

    const container = document.querySelector("#TextScroll-container");
    if(!(container instanceof HTMLElement)) {
      return false;
    }
    const height = container.getBoundingClientRect().height;
    const elements = document.querySelectorAll("#TextScroll-area h3");
    const lastElement = elements[elements.length - 1];
    container.style.height = `calc(${height}px + ${
      lastElement.getBoundingClientRect().height
    }px + 200px)`;
    
    const imageContainer = document.querySelector("#image");

    if(('.TextScroll-wrapper').length > 0) {
      jQuery('.TextScroll-wrapper').parents('body').addClass('removeOverflow');
    }

    const setActiveElement = (element, index) => {
    const img = document.querySelector("#item-image-"+ index);
    const image = document.querySelector("#image img");

    if(!image) {
    const newImage = document.createElement('img');
    newImage.setAttribute('src', img.src);
    imageContainer.append(newImage);
    } else {
    image.src = img.querySelector('img').src;
    }
  
    };
    
    const setActive = () => {
      elements.forEach((element,index) => {
        const { top } = element.getBoundingClientRect();
    
        if (top > 0 && top <= 300) {
          element.setAttribute("id", "active");
          setActiveElement(element, index);
        } else {
          element.removeAttribute("id");
        }
      });
    };
    
    window.document.addEventListener("scroll", () => {
      setActive();
    });
    }